(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header-hulkapps-backup"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.inkeWrapper = this.classList.contains('header-wrapper--inke')
        ? this
        : this.querySelector('.header-wrapper--inke');
      this.utilityBar = document.querySelector('.contact-drawer-bar, .announcement-bar-section, .utility-bar');
      this.leadTimeBar = document.querySelector('.lead-time-message-bar');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setUtilityBarHeight();
      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
      window.addEventListener(
        'resize',
        () => {
          this.setUtilityBarHeight();
          this.setHeaderHeight();
        },
        { passive: true }
      );

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
        this.updateUtilityBarOffset();
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.onTransitionEndHandler = this.onTransitionEnd.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      this.header.addEventListener('transitionend', this.onTransitionEndHandler);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
      this.updateInkeSolidState();
      requestAnimationFrame(() => this.updateInkeSolidState());

      if (window.ResizeObserver && this.header) {
        this.headerResizeObserver = new ResizeObserver(() => this.setHeaderHeight());
        this.headerResizeObserver.observe(this.header);
      }
    }

    setUtilityBarHeight() {
      const leadTimeHeight = this.leadTimeBar ? this.leadTimeBar.offsetHeight : 0;
      const utilityHeight = this.utilityBar ? this.utilityBar.offsetHeight : 0;
      const totalHeight = leadTimeHeight + utilityHeight;

      document.documentElement.style.setProperty('--lead-time-bar-height', `${leadTimeHeight}px`);
      document.documentElement.style.setProperty('--utility-bar-height', `${totalHeight}px`);
      this.updateUtilityBarOffset();
    }

    updateUtilityBarOffset() {
      const totalHeight = parseFloat(
        getComputedStyle(document.documentElement).getPropertyValue('--utility-bar-height')
      ) || 0;

      let offset = 0;
      const headerIsSticky = this.header?.classList.contains('shopify-section-header-sticky');
      const bars = [this.leadTimeBar, this.utilityBar].filter(Boolean);

      if (headerIsSticky && bars.length) {
        const barStillVisible = bars.some((bar) => {
          const rect = bar.getBoundingClientRect();
          return rect.bottom > 0 && rect.top <= 1;
        });
        if (barStillVisible) offset = totalHeight;
      }

      document.documentElement.style.setProperty('--utility-bar-offset', `${offset}px`);
      document.documentElement.classList.toggle('utility-bar-pinned', offset > 0);
    }

    updateInkeSolidState() {
      if (!this.inkeWrapper) return;
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      if (window.ExposureHeaderScroll) {
        window.ExposureHeaderScroll.updateWrapperState(this.inkeWrapper, scrollTop);
      }
    }

    isHomeHeroHeader() {
      return this.inkeWrapper?.classList.contains('header-wrapper--over-hero');
    }

    getHomeHeroThresholds() {
      if (!this.isHomeHeroHeader() || !window.ExposureHeaderScroll) {
        return { pinAt: 0, dismissAt: 0 };
      }
      return window.ExposureHeaderScroll.getThresholds(this.inkeWrapper);
    }

    setHeaderHeight() {
      if (!this.header) return;
      const height = this.header.offsetHeight;
      document.documentElement.style.setProperty('--header-height', `${height}px`);
      document.documentElement.style.setProperty('--header-hide-translate', `-${height + 8}px`);
    }

    setHeaderHiddenState(isHidden) {
      document.body.classList.toggle('header-nav-hidden', isHidden);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
      if (this.header) this.header.removeEventListener('transitionend', this.onTransitionEndHandler);
      if (this.headerResizeObserver) this.headerResizeObserver.disconnect();
      clearTimeout(this.navMarginTimer);
      this.setHeaderHiddenState(false);
    }

    startNavAnimation() {
      this.header.classList.add('header-nav-animating');
    }

    endNavAnimation() {
      this.header.classList.remove('header-nav-animating');
      this.header.style.willChange = '';
    }

    onTransitionEnd(event) {
      if (event.target !== this.header || event.propertyName !== 'transform') return;

      clearTimeout(this.navMarginTimer);
      this.endNavAnimation();

      if (this.header.classList.contains('shopify-section-header-hidden')) {
        this.setHeaderHiddenState(true);
      }
    }

    queueNavStateChange(isHidden) {
      this.startNavAnimation();
      this.header.classList.add('shopify-section-header-sticky');
      this.updateUtilityBarOffset();

      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          this.header.classList.toggle('shopify-section-header-hidden', isHidden);

          clearTimeout(this.navMarginTimer);
          this.navMarginTimer = window.setTimeout(() => {
            if (this.header.classList.contains('shopify-section-header-hidden')) {
              this.setHeaderHiddenState(true);
            }
            this.endNavAnimation();
          }, 400);
        });
      });
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      this.updateInkeSolidState();
      this.updateUtilityBarOffset();

      /* Home hero: the wrapper handles all states via CSS classes — skip Dawn's hide/reveal */
      if (this.isHomeHeroHeader()) {
        this.currentScrollTop = scrollTop;
        return;
      }

      /* Inner pages: standard Dawn hide-on-scroll-down / reveal-on-scroll-up */
      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);
          this.isScrolling = setTimeout(() => { this.preventReveal = false; }, 66);
          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky || this.header.classList.contains('shopify-section-header-hidden')) return;
      this.setHeaderHeight();
      this.queueNavStateChange(true);
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky || !this.header.classList.contains('shopify-section-header-hidden')) return;
      this.setHeaderHeight();
      this.setHeaderHiddenState(false);
      this.queueNavStateChange(false);
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      clearTimeout(this.navMarginTimer);
      this.setHeaderHiddenState(false);
      this.endNavAnimation();
      this.header.classList.remove(
        'shopify-section-header-hidden',
        'shopify-section-header-sticky',
        'header-over-hero-floating',
        'animate'
      );
      this.updateUtilityBarOffset();
      this.updateInkeSolidState();
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
